import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import CustomTable, { CustomColumnProps } from '../../../custom/CustomTable';
import CustomTableContentWrapper from '../../../custom/CustomTableContentWrapper';
import { CaseActionHistoryItem } from '../../../../domain/case/CaseDomains';
import DateFormatUtil from '../../../../util/DateFormatUtil';
import LanguageUtil from '../../../../util/LanguageUtil';
import CaseEventTextUtil from '../../../../util/CaseEventTextUtil';

class ActionHistoryModalComponent extends Component<Props> {
  public render() {
    const { visible, actions, onClose } = this.props;
    return (
      <Dialog
        className={'w-1/2'}
        headerClassName={'!pb-0'}
        header={
          <span className={'text-[15px] text-normal'}>{LanguageUtil.get({ id: 'pages.case.table.actionHistory', defaultMessage: 'Action History' })}</span>
        }
        visible={visible}
        onHide={onClose}
        dismissableMask
        closeOnEscape
      >
        <CustomTable columns={this.getColumns()} value={actions} />
      </Dialog>
    );
  }

  private getColumns = (): CustomColumnProps[] => {
    return [
      {
        field: 'type',
        header: LanguageUtil.get({ id: 'pages.case.actionHistory.type', defaultMessage: 'Type' }),
        sortable: false,
        body: (record: CaseActionHistoryItem) => (
          <div className={'text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={CaseEventTextUtil.getTypeText(record)} />
          </div>
        ),
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.case.actionHistory.detail', defaultMessage: 'Detail' }),
        sortable: false,
        body: (record: CaseActionHistoryItem) => (
          <div className={'text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={CaseEventTextUtil.getDetail(record)} />
          </div>
        ),
      },
      {
        field: 'username',
        header: LanguageUtil.get({ id: 'pages.case.actionHistory.username', defaultMessage: 'Username' }),
        sortable: false,
        body: (record: CaseActionHistoryItem) => (
          <div className={'text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={record.username} />
          </div>
        ),
      },
      {
        field: 'timestamp',
        header: LanguageUtil.get({ id: 'pages.case.actionHistory.timestamp', defaultMessage: 'Timestamp' }),
        sortable: false,
        body: (record: CaseActionHistoryItem) => (
          <div className={'text-xs 2xl:text-md'}>
            <CustomTableContentWrapper text={DateFormatUtil.formatEpochForDisplay(record.timestamp)} />
          </div>
        ),
      },
    ];
  };
}

interface Props {
  visible: boolean;
  actions: CaseActionHistoryItem[];
  onClose: () => void;
}

export default ActionHistoryModalComponent;
